import React, { Component } from 'react';
import {
    List,
    EditButton,
    DeleteButton,
    Pagination,
    Datagrid,
    TextField,
    BooleanField,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    BooleanInput
} from 'react-admin';

class AHRIList extends Component {
    render() {
        return (
            <List title="AHRI" {...this.props} pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100]} />}>
                <Datagrid>
                    <TextField source="version" sortable={true}></TextField>
                    <BooleanField source="currentVersion"></BooleanField>
                    <BooleanField source="testVersion"></BooleanField>
                    <EditButton />
                    <DeleteButton />
                </Datagrid>
            </List>
        );
    }
}

class AHRIEdit extends Component {
    render() {
        return (
            <Edit {...this.props} redirect="/HEXSelector/ahri">
                <SimpleForm>
                    <TextInput label="Version" source="version"></TextInput>
                    <BooleanInput label="Current Version" source="currentVersion"></BooleanInput>
                    <BooleanInput label="Test Version" source="testVersion"></BooleanInput>
                    <TextInput label="Armstrong Version" source="armstrongVersion"></TextInput>
                    <TextInput label="DHT Version" source="dhtVersion"></TextInput>
                    <TextInput label="Grundfos Version" source="grundfosVersion"></TextInput>
                    <TextInput label="PlateConcepts Version" source="plateConceptsVersion"></TextInput>
                    <TextInput label="Polaris Version" source="polarisVersion"></TextInput>
                    <TextInput label="AIC Version" source="aicVersion"></TextInput>
                    <TextInput label="Wessels Version" source="wesselsVersion"></TextInput>
                    <TextInput label="Tanpera Version" source="tanperaVersion"></TextInput>
            </SimpleForm>
            </Edit>
        )
    }
}

class AHRICreate extends Component {
    render() {
        return (
            <Create {...this.props} redirect="/HEXSelector/ahri">
                <SimpleForm>
                    <TextInput label="Version" source="version"></TextInput>
                    <BooleanInput label="Current Version" source="currentVersion"></BooleanInput>
                    <BooleanInput label="Test Version" source="testVersion"></BooleanInput>
                    <TextInput label="Armstrong Version" source="armstrongVersion"></TextInput>
                    <TextInput label="DHT Version" source="dhtVersion"></TextInput>
                    <TextInput label="Grundfos Version" source="grundfosVersion"></TextInput>
                    <TextInput label="PlateConcepts Version" source="plateConceptsVersion"></TextInput>
                    <TextInput label="Polaris Version" source="polarisVersion"></TextInput>
                    <TextInput label="AIC Version" source="aicVersion"></TextInput>
                    <TextInput label="Wessels Version" source="wesselsVersion"></TextInput>
                    <TextInput label="Tanpera Version" source="tanperaVersion"></TextInput>
                </SimpleForm>
            </Create>
        )
    }
}

export { AHRIList, AHRICreate, AHRIEdit }